@import ../../../styles/helpers

.main_container
    width: 100%
    max-width: 1070px
    height: 100%
    margin: 0 auto
    display: flex
    flex-direction: column
    border-radius: $border_radius_big
    background-color: $page_background
    position: relative
    +m
        gap: 0px
        background-color: $page_background
        border-radius: 0
        padding-bottom: 15px !important
